import { ADD_MEMBER, ADD_MEMBER_ERROR, DELETE_MEMBER, RESET_ADD_MEMBER, UPDATE_USER, UPDATE_USER_ERROR, USER_OPTIONS, LOGO_UPDATE } from '../../Actions/actionTypes'

export const addMember = newMember => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
  
      const firestore = getFirestore();
  
      firestore
        .collection(newMember.companyId)
        .doc('companyUsers')
        .collection('clients')
        .doc(newMember.email)
        .set({
          name: newMember.name,
          dob: newMember.dateOfBirth,
          email: newMember.email,
          gender: newMember.gender,
          memberId: newMember.uniqueId,
          createdDate: new Date(),
          trainer: newMember.trainer,

        })
        .then(resp => {
        
          // return firestore
          //   .collection(newMember.company)
          //   .doc(resp.id)
          //   .set({
          //     name: newMember.name,
          //     dob: newMember.dateOfBirth,
          //     email: newMember.email,
          //     gender: newMember.gender,
          //     memberId: resp.id,
          //     createdDate: new Date(),
          //     NoTests: '0'
          //     // uniqueId: Math.floor(Math.random() * 10000000000000000),
              
          //   });
        })
        .then(() => {
          dispatch({ type: ADD_MEMBER, payload: newMember});
        })
        .catch(error => {
          dispatch({ type: ADD_MEMBER_ERROR, error });
        });
    };
  };
  
  export const deleteMember = (companyId,memberId) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
      const firestore = getFirestore();
      firestore
        .collection(companyId)
        .doc('companyUsers')
        .collection('clients')
        .doc(memberId)
        .delete()
        .then(() => {
          dispatch({ type: DELETE_MEMBER });
         // console.log('member withid ', memberId, 'is Deleted')
        })
        .catch(err => {
         // console.log("Delete Member Actions: ", err);
    
        });
    };
  };
  
  export const updateUser = newData => {
    console.log("USER UPDATE 1", newData)
    return (dispatch, getState, { getFirebase, getFirestore }) => {
      const firestore = getFirestore();
      firestore
        .collection("users")
        .doc(newData.id)
        .update(newData)
        .then(() => {
          dispatch({ type: UPDATE_USER, payload: newData });
          console.log("USER UPDATE 2", newData)
        })
        .catch(err => {
          console.log("Updade Actions: ", err);
          dispatch({type: UPDATE_USER_ERROR, err})
        });
    };
  };

export const resetAddMember = () => {

    return (dispatch, getState) => {
      dispatch({ type: RESET_ADD_MEMBER })
    }

}

export const userOptionsColors = newData => {
  console.log("USER OPTIONS 1", newData)
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    firestore
      .collection(newData.companyId)
      .doc("companyOptions")
      .update({
        "colors": newData
      })
      .then(() => {
        dispatch({ type: USER_OPTIONS, payload: newData });
        console.log("USER OPTIONS 2", newData)
      })
      .catch(err => {
        console.log("Updade Actions: ", err);
        //dispatch({type: UPDATE_USER_ERROR, err})
      });
  };
};

export const logoUpdate = newData => {
  console.log("Logo OPTIONS 1", newData)
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    firestore
      .collection(newData.companyId)
      .doc("companyOptions")
      .update({
        "logo": newData
      })
      .then(() => {
        dispatch({ type: LOGO_UPDATE, payload: newData });
        console.log("USER OPTIONS 2", newData)
      })
      .catch(err => {
        console.log("Updade Actions: ", err);
        //dispatch({type: UPDATE_USER_ERROR, err})
      });
  };
};